import { render, staticRenderFns } from "./LabelView.vue?vue&type=template&id=8614b40e"
import script from "./LabelView.vue?vue&type=script&lang=js"
export * from "./LabelView.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports